import React, { useState } from 'react';
import { courses } from '../data';

export default function Courses() {
  const [expanded, setExpanded] = useState<number | null>(null);

  // ✅ Show all courses directly
  const visible = courses;

  return (
    <section id="courses" className="py-24 md:py-32 relative" style={{background:'#0A0A14'}}>
      <div className="grid-bg absolute inset-0 opacity-50" />
      <div className="orb w-80 h-80 top-20 left-0 opacity-10" style={{background:'rgba(74,144,226,0.5)'}} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 reveal">
          <div>
            <span className="section-tag">What We Offer</span>
            <h2 className="font-playfair font-black text-white leading-tight" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(2rem,3.5vw,3rem)'}}>
              400+ Courses Across<br/>
              <span style={{color:'#C8A84B'}}>Every Domain</span>
            </h2>
          </div>
          <p style={{color:'rgba(212,207,197,0.6)',maxWidth:'340px',fontSize:'0.9rem',lineHeight:'1.7'}}>
            Basic · Intermediate · Advanced levels in every category. Choose your path, we'll guide you there.
          </p>
        </div>

        {/* Courses Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-[2px]">
          {visible.map((course, i) => (
            <div
              key={course.id}
              className="reveal hover-lift cursor-pointer"
              style={{animationDelay:`${i*0.07}s`}}
              onClick={() => setExpanded(expanded === course.id ? null : course.id)}
            >
              <div className={`h-full p-8 border transition-all duration-400 ${expanded === course.id ? 'border-yellow-500/40' : 'border-transparent'}`}
                style={{background: expanded === course.id ? 'rgba(200,168,75,0.05)' : 'rgba(15,22,41,0.9)'}}>

                {/* Top row */}
                <div className="flex items-start justify-between mb-5">
                  <div className="w-14 h-14 flex items-center justify-center text-2xl rounded-sm border transition-all duration-300" style={{
                    background: expanded === course.id ? '#C8A84B' : 'rgba(200,168,75,0.08)',
                    borderColor: 'rgba(200,168,75,0.2)'
                  }}>
                    {course.icon}
                  </div>
                  <span style={{fontFamily:'Space Mono,monospace',fontSize:'0.68rem',color:'rgba(200,168,75,0.35)',letterSpacing:'1px'}}>
                    {String(course.count).padStart(2,'0')} courses
                  </span>
                </div>

                <h3 className="text-white font-bold text-lg mb-2" style={{fontFamily:'Playfair Display,serif'}}>
                  {course.name}
                </h3>
                <p style={{color:'rgba(212,207,197,0.55)',fontSize:'0.82rem',lineHeight:'1.7'}} className="mb-4">
                  {course.description}
                </p>

                {/* Level badges */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {course.levels.map(level => (
                    <span key={level} className="px-2 py-0.5 text-[10px] tracking-wider uppercase rounded-sm"
                      style={{background:'rgba(200,168,75,0.08)',border:'1px solid rgba(200,168,75,0.15)',color:'rgba(200,168,75,0.7)'}}>
                      {level}
                    </span>
                  ))}
                </div>

                {/* Expandable course list */}
                {expanded === course.id && (
                  <div className="mt-4 pt-4 border-t" style={{borderColor:'rgba(200,168,75,0.15)'}}>
                    <div style={{fontSize:'0.72rem',letterSpacing:'2px',textTransform:'uppercase',color:'#C8A84B',marginBottom:'10px',fontFamily:'Space Mono,monospace'}}>
                      Featured Courses
                    </div>
                    <ul className="space-y-2">
                      {course.courses.map((c, ci) => (
                        <li key={ci} className="flex items-center gap-2" style={{color:'rgba(212,207,197,0.65)',fontSize:'0.82rem'}}>
                          <span style={{color:'#C8A84B',fontSize:'0.6rem'}}>✦</span>
                          {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="flex items-center justify-between mt-4">
                  <span style={{color:'rgba(212,207,197,0.35)',fontSize:'0.72rem'}}>
                    Click to {expanded === course.id ? 'collapse' : 'expand'}
                  </span>
                  <span className="w-8 h-8 flex items-center justify-center rounded-full border text-sm transition-all duration-300"
                    style={{borderColor:'rgba(200,168,75,0.2)',color:'#C8A84B',transform: expanded === course.id ? 'rotate(45deg)' : ''}}>
                    →
                  </span>
                </div>

              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16 reveal">
          <p style={{color:'rgba(212,207,197,0.5)',marginBottom:'20px',fontSize:'0.9rem'}}>
            Can't find what you're looking for? We offer 400+ courses total.
          </p>
          <button 
            onClick={() => document.querySelector('#contact')?.scrollIntoView({behavior:'smooth'})}
            className="btn-gold text-sm tracking-widest uppercase font-bold">
            Talk to Our Counselor →
          </button>
        </div>
      </div>
    </section>
  );
}